import Head from "next/head";
import { END } from "redux-saga";
import { useSelector } from "react-redux";

import PrivacyPolicy from "../src/components/pages/privacyPolicy/PrivacyPolicy";

import { wrapper } from "../src/config/Store";
import { getAllCMS } from "../src/redux/cms/CMSActions";
import constants from "../src/utils/Constants";
import Routes from "../src/routes/Routes";

const { CMS_TYPES } = constants;
const pageParams = {
  type: CMS_TYPES.OTHER_PAGE,
  slug: "privacy-policy",
};

const nextPrivacyPolicy = () => {
  const mPageMetaDetails = useSelector(({ cms }) => {
    const boardKey = JSON.stringify(pageParams);

    const boards = cms.boards;
    const mPageDetailsId = boards[boardKey]?.list?.[0];
    return cms.cmsMap[mPageDetailsId]?.meta?.pageMeta || {};
  });

  return (
    <>
      <Head>
        <title>{mPageMetaDetails?.title}</title>
        <meta name="description" content={mPageMetaDetails?.description} />
        <meta itemProp="name" content="" />
        <meta itemProp="description" content="" />
        <meta itemProp="image" content="" />
        <link
          rel="canonical"
          href={`${Routes?.domain}${Routes?.privacy_policy}`}
        />
      </Head>

      <PrivacyPolicy />
    </>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(
  (store) => async (context) => {
    const boards = store.getState().cms.boards;
    const pageBoard = boards[JSON.stringify(pageParams)];

    if (!pageBoard) {
      store.dispatch(getAllCMS(pageParams));
      store.dispatch(END);
    }

    await store.sagaTask.toPromise();
  }
);

export default nextPrivacyPolicy;
